<template>
  <div class="preview-loading">
    <van-loading size="24px" vertical type="spinner" color="#1989fa">正在进入预览模式...</van-loading>
  </div>
</template>

<script>
export default {
  name: 'PreviewAuth',
  async created() {
    const { id } = this.$route.query
    if (!id) {
      this.$toast.fail('无效的预览链接')
      return
    }

    try {
      // 1. 调用免登录接口
      const res = await this.$api.previewAuth(id)
      if (res.code === 0) {
        const { accessToken, userMobile, userName, userId, ticketType } = res.data
        
        // 2. 存储 Token 和用户信息
        localStorage.setItem('access_token', accessToken)
        
        // 存储用户信息
        localStorage.setItem('loginphone', userMobile)
        localStorage.setItem('nickname', userName)
        // 设置 Vuex store 中的 nickname
        this.$store.commit("setNickname", userName)
        localStorage.setItem('userInfo', JSON.stringify({
          mobile: userMobile,
          realName: userName,
          userName: userName, // 添加 userName 字段
          username: userMobile,
          id: userId // 使用返回的userId
        }))
        
        localStorage.setItem('entrCode', ticketType)
        
        // 3. 设置预览模式标识
        localStorage.setItem('isPreviewMode', 'true')
        
        // 4. 跳转到首页
        this.$toast.success('进入预览模式')
        
        // 确保 Token 写入后再跳转
        setTimeout(() => {
          this.$router.replace('/')
        }, 500)
      } else {
        this.$toast.fail(res.msg || '预览链接无效或已过期')
        //清空缓存
        localStorage.clear()
        // 跳转到登录页
        this.$router.replace('/login')
      }
    } catch (e) {
      console.error('预览模式进入失败', e)
      this.$toast.fail('进入预览模式失败')
      //清空缓存
      localStorage.clear()
      // 跳转到登录页
      this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.preview-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f7f8fa;
}
</style>

